export class CertificateTakeCareOfStudent{
    id : number;
    studentId : number;
    courseName : string; 
    courseDate : Date;
    timeStudy : string; 
    placeOfStudy : string;
    certificateName: string;
    note : string; 
    typeOfCertificationId:number;
    disTutorType:number;
} 